import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'send-password-email',
    templateUrl: 'send-password-email.component.html',
    styleUrls: ['send-password-email.component.scss']
})
export class SendPasswordEmailComponent {
    public userEmail: string;
    public EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    @ViewChild('sendEmailForm', { static: false}) sendEmailForm: ElementRef;

    constructor(private _router: Router,
        private _location: Location,
        private _autoLoginClient: AutoLoginClient,
        private _translateService: TranslateService,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) {
    }

    public back() {
        this._location.back();
    }

    public sendEmail() {
        if (this.isEmailValid(this.sendEmailForm)) {
            this._autoLoginClient.sendVerificationCode(this.userEmail).subscribe((response) => {
                switch (response) {
                    case 'SendVerificationCodeSuccessful':
                        this._router.navigate(['email-sent']);
                        break;
                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION'), 'error');
                        break;
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.MISSING_SMTP_CONFIGURATION'), 'error');
                        break;
                    case 'SendVerificationCodeUserNotFound':
                    case 'SendVerificationCodeUnexpectedError':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR'), 'error');
                        break;
                    default:
                        this._showToastService.showToast(this._i18nService.instant('GLOBAL.GENERIC_ERROR_MSG'), 'error');
                        break;
                }
            });
        }
    }

    private isEmailValid(form): boolean {
        let isValid = true;
        if (!this.userEmail || this.userEmail === '' || form.form.controls.userEmailInput.invalid) {
            isValid = false;
        }
        return isValid;
    }
}
